import { AttachmentPreview, MultimediaList } from 'portal-commons';
import { FC, useEffect, useState } from 'react';

import { Section, SectionTitle } from './atoms';
import { ATTACHMENT_FOLDER } from '../../constants';
import { Attachment, CampaignDetail, attachmentController } from '@/apis/core';
import { generateAndDownloadFile } from '@/utils/file';

interface MultimediaUploadSectionProps {
  campaign: CampaignDetail;
}

const MultimediaUploadSection: FC<MultimediaUploadSectionProps> = ({
  campaign,
}) => {
  const [loading, setLoading] = useState(false);
  const [attachments, setAttachments] = useState<Attachment[]>([]);
  const [previewAttachment, setPreviewAttachment] = useState<Attachment>();

  const fetchAttachments = async (campaignUid: string) => {
    setLoading(true);
    const response = await attachmentController.getCampaignAttachments(
      campaignUid,
      ATTACHMENT_FOLDER.SUPPORTING_DOC
    );
    setAttachments(response);
    setLoading(false);
  };

  const handleDownload = async (index: number) => {
    const attachment = attachments[index];
    if (attachment) {
      setLoading(true);
      const response = await attachmentController.download(attachment.uuid, {
        filename: attachment.fileName,
      });
      if (response?.file) {
        generateAndDownloadFile(response.file);
      }
      setLoading(false);
    }
  };

  const handlePreview = async (index: number) => {
    const attachment = attachments[index];
    if (attachment) {
      setLoading(true);
      const response = await attachmentController.download(attachment.uuid, {
        filename: attachment.fileName,
      });
      if (response?.file) {
        setPreviewAttachment({
          ...attachment,
          file: response.file,
        });
      }
      setLoading(false);
    }
  };

  const handlePreviewClose = () => {
    setPreviewAttachment(undefined);
  };

  useEffect(() => {
    fetchAttachments(campaign.uid);
  }, [campaign.uid]);

  return (
    <Section>
      <SectionTitle note="Provides an area to upload any supporting information for opt-in, call-to-action, terms and conditions, privacy policy, etc.">
        Multimedia Upload for Supporting Documents
      </SectionTitle>
      <MultimediaList
        title="Multimedia Files"
        loading={loading}
        attachments={attachments}
        onDownload={handleDownload}
        onSelect={handlePreview}
      />
      {previewAttachment?.file && (
        <AttachmentPreview
          file={previewAttachment.file}
          mimeType={previewAttachment.mimeType}
          onClose={handlePreviewClose}
        />
      )}
    </Section>
  );
};

export default MultimediaUploadSection;
